import { TableRow, TableCell, SxProps, useTheme, Box, Paper, Table, TableBody, TableContainer, TableHead, Typography } from "@mui/material"
import { Link } from "react-router-dom"
import { Campsite } from "../../../clients"

interface MyAccountMembershipCampsitesProps {
    sx?: SxProps
    campsites: Campsite[]
}

export const MyAccountMembershipCampsites = ({ sx, campsites }: MyAccountMembershipCampsitesProps) => {

    const theme = useTheme()

    const renderCampsiteRow = (campsite: Campsite) => {
        return <CampsiteRow key={campsite.id} campsite={campsite} />
    }

    return (
        <Paper sx={{ ...sx, border: '1px solid', borderColor: theme.palette.secondary.main, borderRadius: '3px', p: 2 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography>Campsites</Typography>
            </Box>
            <TableContainer sx={sx} component={Box}>
                <Table sx={{ minWidth: 500 }} aria-label='Campsites'>
                    <TableHead>
                        <TableRow>
                            <TableCell>Campsite</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {campsites.map(renderCampsiteRow)}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    )
}

interface CampsiteRowProps {
    campsite: Campsite
}

const CampsiteRow = ({ campsite }: CampsiteRowProps) => {
    return (
        <TableRow>
            <TableCell>
                <Link style={{ textDecoration: 'none' }} to={`/campsites/${campsite.id}`}>Campsite #{campsite.number}</Link>
            </TableCell>
        </TableRow>
    )
}